<template>
  <div id="app">
    <t-header v-show="$route.meta.show"></t-header>
    <div class="flex_content flex_center">
      
        <router-view v-if="isRouterAlive"></router-view>
     
       
    </div>
    <t-footer v-show="$route.meta.show"></t-footer>
  </div>
</template>

<script>
import tHeader from './components/header.vue'
import tFooter from './components/footer.vue'
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  components:{
    tHeader,
    tFooter
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  
  methods:{
    reload () {
      this.isRouterAlive = false
      let that = this
      this.$nextTick(function () {
        that.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang='scss'>
@import '../src/style/theme.scss';
#app {
  font-family: neo-sans,Helvetica Neue,Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  text-size-adjust:100%;
  min-height:100vh;
  overflow: hidden;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height:1.6;
  // line-height: 1.6;
  letter-spacing:0 !important;
  display: flex;
  flex-direction: column;
  .flex_content{
    flex:1;
    padding-bottom:20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue